
// RetroPixel Gaming Quest - Conditional Mockup Display
// Hides product media gallery until a phone model is selected
(function() {
  'use strict';
  
  function initConditionalMockups() {
    const productPage = document.querySelector('[data-testid="product-information"]');
    if (!productPage) return;
    
    const mediaContainer = document.querySelector('[data-testid="product-information-media"]');
    if (!mediaContainer) return;
    
    // Check if a variant is already selected (from URL or default)
    const variantPicker = document.querySelector('variant-picker, .variant-picker');
    if (!variantPicker) return;
    
    // Get currently selected variant inputs
    const selectedInputs = document.querySelectorAll('.variant-picker input:checked, .variant-picker [aria-checked="true"]');
    const hasSelection = selectedInputs.length > 0;
    
    if (!hasSelection) {
      // Hide media and show a prompt
      mediaContainer.style.opacity = '0.15';
      mediaContainer.style.transition = 'opacity 0.4s ease';
      mediaContainer.style.pointerEvents = 'none';
      
      // Add prompt overlay
      const prompt = document.createElement('div');
      prompt.id = 'rpgq-model-prompt';
      prompt.style.cssText = `
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: rgba(13, 15, 26, 0.92);
        border: 1px solid #c9a84c;
        border-radius: 8px;
        padding: 20px 28px;
        text-align: center;
        color: #c9a84c;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0.05em;
        z-index: 10;
        pointer-events: none;
        white-space: nowrap;
      `;
      prompt.innerHTML = '&#9654; Select your phone model to see the design';
      
      const mediaWrapper = mediaContainer.parentElement || mediaContainer;
      mediaWrapper.style.position = 'relative';
      mediaWrapper.appendChild(prompt);
    }
    
    // Listen for variant selection
    function onVariantChange() {
      mediaContainer.style.opacity = '1';
      mediaContainer.style.pointerEvents = '';
      const existingPrompt = document.getElementById('rpgq-model-prompt');
      if (existingPrompt) {
        existingPrompt.style.opacity = '0';
        setTimeout(() => existingPrompt.remove(), 400);
      }
    }
    
    // Listen on all variant inputs
    document.querySelectorAll('.variant-picker input, .variant-picker label').forEach(el => {
      el.addEventListener('change', onVariantChange);
      el.addEventListener('click', onVariantChange);
    });
    
    // Also listen for Shopify variant change events
    document.addEventListener('variant:change', onVariantChange);
    document.addEventListener('variantChange', onVariantChange);
  }
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initConditionalMockups);
  } else {
    initConditionalMockups();
  }
  
  // Also run after Shopify section loads (for dynamic rendering)
  document.addEventListener('shopify:section:load', initConditionalMockups);
})();
